import { z } from 'zod'

export const PaymentMethod = z.enum(['iban', 'lydia', 'wero', 'paypal', 'direct'])
export type PaymentMethod = z.infer<typeof PaymentMethod>

export const CreateParticipationRequest = z.object({
  itemId: z.string(),
  guestName: z.string().min(1).max(100),
  guestEmail: z.string().email(),
  amountCents: z.number().int().positive().max(10_000_000),
  message: z.string().max(2000).nullable().optional(),
  paymentMethod: PaymentMethod,
  turnstileToken: z.string().min(1),
})
export type CreateParticipationRequest = z.infer<typeof CreateParticipationRequest>

export const ParticipationCreatedResponse = z.object({
  ok: z.literal(true),
  participationId: z.string(),
  alreadyGivenCents: z.number().int(),
  remainingCents: z.number().int(),
  complete: z.boolean(),
})
